// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xetl","index":"styles_index__1zsTG"};